import { render, staticRenderFns } from "./Submitted-War.vue?vue&type=template&id=1c9d4a7b"
import script from "./Submitted-War.vue?vue&type=script&lang=js"
export * from "./Submitted-War.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports